<template>
  <div class='langlist'>
    <navbar>
      <template #title>
        <span style="color: #fff;">{{ $t('cont.t01') }}</span>
      </template>
      <template #left>
        <van-icon name="arrow-left" color="#fff" size="18" />
      </template>
    </navbar>
    <!--    <div class="list">-->
    <!--      <div class="item" v-for="(item, index) in langList" :key="index" @click="langChange(item.lang)">-->
    <!--        {{ item.label }}-->
    <!--      </div>-->
    <!--    </div>-->
    <div class="list">
      <div class="item" v-for="(item, index) in langList" :key="index" @click="langChange(item.lang)">
        <div class="l">
          <van-icon name="other-pay" size=".42rem" />
          {{ item.label }}
        </div>
        <div class="r">
          <van-icon name="arrow" color="#fff" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      langList: [
        {
          label: 'English',
          lang: 'en'
        },
        {
          label: 'German',
          lang: 'de'
        },
        {
          label: 'français',
          lang: 'fr'
        },
        {
          label: 'Português',
          lang: 'pt'
        },
        {
          label: 'Spain',
          lang: 'es'
        },
        {
          label: 'Indonesia',
          lang: 'yinni'
        },
        {
          label: 'Vietnam',
          lang: 'yn'
        },
        {
          label: 'Turkey',
          lang: 'trq'
        },
        {
          label: 'Australia',
          lang: 'en'
        },
        {
          label: '한국인',
          lang: 'ko'
        },
        {
          label: '日本語',
          lang: 'ja'
        },
        {
          label: '中文',
          lang: 'zh'
        },
        {
          label: 'Italiano',
          lang: 'it'
        }
        // {
        //   label: '中文繁体',
        //   lang: 'zt'
        // }
      ],
      language: localStorage.getItem("locale") || "zh"
    }
  },
  mounted() {

  },
  computed: {},
  methods: {
    langChange(lang) {
      localStorage.setItem("locale", lang);
      this.$i18n.locale = this.language
      // this.$store.commit('SET_LOCAL_LANG', {
      //   code: lang
      // })
      this.$router.go(-1)
      setTimeout(() => {
        window.location.reload()
      }, 500);
    },
  },
}
</script>
<style lang='less' scoped>
.langlist {
  min-height: 100vh;

  .list {
    padding: 0 .42rem;
    // border-bottom: 1px solid #ebedf0;

    .item {
      display: flex;
      justify-content: space-between;
      border-bottom: .04rem solid #121212;
      padding: .26rem 0;
      margin-top: .3rem;
      color: #fff;

      // &:last-child {
      //   border-bottom: none;
      // }

      .l {
        font-size: .37rem;
        display: flex;
        gap: .1rem;
        align-items: baseline;
      }

      .r {
        font-size: .42rem;
        display: flex;
        align-items: baseline;
      }
    }
  }
}
</style>
